export default {
  en: {
    trainerspelling: {
      heading: 'Spelling',
      description: 'Train with diverse spelling exercises to not get overwhelmed by the radio alphabet.',
      skip: 'Skip',
      table: {
        short: 'Short',
        long: 'Long',
        hover: '(hover to unblur)',
        blur: 'Blur',
        youranswer: 'Your answer',
      }
    }
  },
  de: {
    trainerspelling: {
      heading: 'Rechtschreibung',
      description: 'Trainiere mit verschiedenen Rechtschreibübungen, um nicht von dem Funkalphabet überwältigt zu werden.',
      skip: 'Überspringen',
      table: {
        short: 'Kurz',
        long: 'Lang',
        hover: '(zum Aufdecken hovern)',
        blur: 'Verblassen',
        youranswer: 'Deine Antwort',
      }
    }
  },
  es: {
    trainerspelling: {
      heading: 'Ortografía',
      description: 'Entrena con diversos ejercicios de ortografía para no sentirte abrumado por el alfabeto radiofónico.',
      skip: 'Saltar',
      table: {
        short: 'Corto',
        long: 'Largo',
        hover: '(pasar el ratón para desenfocar)',
        blur: 'Desenfocar',
        youranswer: 'Tu respuesta',
      }
    }
  },
  uk: {
    trainerspelling: {
      heading: 'Правопис',
      description: 'Тренуйтеся з різноманітними вправами на правопис, щоб не відчувати себе перевантаженим радіоалфавітом.',
      skip: 'Пропустити',
      table: {
        short: 'Короткий',
        long: 'Довгий',
        hover: '(наведіть курсор, щоб розблокувати)',
        blur: 'Розмиття',
        youranswer: 'Ваша відповідь',
      }
    }
  }
}
